import { useState } from "react";
import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

type Props = {
  tooltipText?: string;
  title?: string;
  description?: string;
  className?: string;
};

export default function BulkOrderInfo({
  tooltipText = "Bulk Order: importa fino a 30 righe e lascia al fornitore la pianificazione tra checkout e check-in.",
  title = "Bulk Order (beta)",
  description = "Pensato per apartment manager: importi molte richieste in pochi minuti. Il fornitore assegna gli orari rispettando la finestra checkout→check-in (meno buffer).",
  className,
}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            className={className}
            aria-label="Info Bulk Order"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
            }}
          >
            <Info className="h-4 w-4 text-muted-foreground" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[260px]">
          {tooltipText}
        </TooltipContent>
      </Tooltip>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent className="w-full sm:max-w-lg">
          <SheetHeader>
            <SheetTitle>{title}</SheetTitle>
            <SheetDescription>{description}</SheetDescription>
          </SheetHeader>

          <div className="mt-5 space-y-4 text-sm text-gray-700">
            <div className="space-y-2">
              <div className="font-medium text-gray-900">Come funziona</div>
              <ul className="list-disc pl-5 space-y-1">
                <li>Selezioni fornitore e servizio (puoi anche cambiare servizio riga per riga).</li>
                <li>Incolli fino a 30 righe con indirizzo, checkout e check-in.</li>
                <li>L’app calcola la finestra disponibile (check-in meno buffer).</li>
                <li>Il fornitore assegna l’orario nel calendario entro la finestra consentita.</li>
              </ul>
            </div>

            <div className="space-y-2">
              <div className="font-medium text-gray-900">Quando conviene usarlo</div>
              <ul className="list-disc pl-5 space-y-1">
                <li>Hai molti appartamenti e vuoi caricare i cambi velocemente.</li>
                <li>Vuoi evitare errori manuali nel coordinamento checkout/check-in.</li>
              </ul>
            </div>

            <div className="space-y-2">
              <div className="font-medium text-gray-900">Limitazioni (beta)</div>
              <ul className="list-disc pl-5 space-y-1">
                <li>Massimo 30 righe per batch.</li>
                <li>Serve autenticazione e un telefono di contatto.</li>
              </ul>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}

